module.exports = __webpack_public_path__ + "static/media/badlands-logo-light.b42c430e.png";